import { Component, Input, OnInit } from '@angular/core';

import {PageHelper, PageNode} from '../../../common/services';

@Component({
  selector: 'p8-bdc-categories-detail',
  templateUrl: './categories-detail.component.html',
  styleUrls: ['./categories-detail.component.scss']
})
export class CategoriesDetailComponent implements OnInit {
  @Input() category: PageNode;

  constructor(private pageHelper: PageHelper) { }

  ngOnInit() {
  }

  /**
   * Choisi les max pages favorites, si on n'en trouve pas, prend les max 1ères pages
   * @param listPages
   * @param max
   * @private
   */
  _getFavOrMaxPages(listPages: PageNode[], max = 5) {
    let favouriteLimitedPages = listPages.filter((_page) => _page.data.is_favourite).slice(0, max);
    if (favouriteLimitedPages.length === 0) {
      favouriteLimitedPages = listPages.slice(0, max);
    }
    return favouriteLimitedPages;
  }

  /**
   * Obtention des pages "publiées" d'une catégorie, les 5 premières
   * - en priorité les pages marquées "is_favorite"
   * - si aucune ne l'est, on prendre les 5 1ères du lot
   * @param {PageNode[]} pages : pages|rubriques children
   */
  collapseNodes(pages: PageNode[]): PageNode[] {
    if (!pages) {
      return [];
    }

    const listPages = pages.filter((_page) => _page.data.is_published);

    const favouriteLimitedPages = this._getFavOrMaxPages(listPages);

    this.pageHelper.sortPages(favouriteLimitedPages);

    const collapsedPages: PageNode[] = [];
    for (const page of favouriteLimitedPages) {
      collapsedPages.push(page);
      collapsedPages.concat(this.collapseNodes(page.children));
    }

    return collapsedPages;
  }

  /**
   * Mise en plat / remontées des pages feuilles de chaque catégorie
   * @param {PageNode[]} pages : pages|rubriques children
   * @param {PageNode[]} pagesOnly : pages uniquement à afficher (remontée de toutes les pages feuilles des rubriques du thème)
   * @example
   * categorie 1 children (input flatteningNodes) :
   *   ----- caté 1 ---- page 1
   *                ----- caté 2 ----- page 4
   *                             ----- page 5
   *                ---- page 2
   *   ----- cate 2
   * les pages retournées pour caté 1 : page 1, page 4, page 5, page 2
   */
  flatteningNodes(pages: PageNode[], pagesOnly: PageNode[] = []): PageNode[] {
    if (!pages) {
      return [];
    }

    const listPages = pages.filter((_page) => _page.data.is_published);
    listPages.forEach((_node) => {
      if ((!_node.children || _node.children.length === 0) ) { // page
        pagesOnly.push(_node);
      } else { // rubrique
        pagesOnly.concat(this.flatteningNodes(_node.children, pagesOnly));
      }
    });

    this.pageHelper.sortPagesByTitle(pagesOnly);
    return this._getFavOrMaxPages(pagesOnly);
  }
}
